module.exports = __webpack_public_path__ + "img/beneficios2.d11705b4.jpg";